import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import axios from 'axios';
import './Projection.css'

import { Api } from '../../../services/api';
import ProjectionSettingViewModal from './projection-modal/projection-setting-view-model';
import ProjectionAddModel from './projection-modal/projection-add';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { FaFileExcel, FaSave, FaPlus } from 'react-icons/fa';
import { IoMdRefresh } from "react-icons/io";
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

const Projection = () => {

    const [projection, setProjection] = useState([]);
    const [ColumnName, setColumnName] = useState([]);
    const [ColumnNameKey, setColumnNameKey] = useState([]);
    const [ColumnReComplated, setColumnReComplated] = useState({});


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isProjectionSetting, setIsProjectionSetting] = useState(false);


    const [isLoading, setIsLoading] = useState(true); // Add loading state
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);

    const [selectOnStartDate, setSelectOnStartDate] = useState('2023-01-01')
    const [selectOnEndDate, setSelectOnEndDate] = useState('2025-12-31')

    useEffect(() => {
        console.log('Fetching projects...');
        getProjection();

    }, []);




    const getProjection = async () => {
        setIsLoading(true);
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        axios.get(Api.API_BASE_URL + 'get-income-statement', { headers })
            .then((response) => {
                ;
                setProjection(response.data.result);
                setColumnNameKey(response.data.ColumnValue)
                setColumnName(response.data.ColumnName)
                setColumnReComplated(response.data.ColumnReComplated)

                setSelectOnEndDate(response.data.endDate)
                setSelectOnStartDate(response.data.startDate)


                setIsLoading(false);
            })
            .catch((error) => {

                setIsLoading(false);
            });
    }



    const rowClass = (data) => {

        return {
            'selected-row': selectedProduct && selectedProduct['INCOME STATEMENT'] === data['INCOME STATEMENT'],
            'yellow-200': data['INCOME STATEMENT'] == "Sub Total",
            'font-bold': data['INCOME STATEMENT'] == 'Cash - end',

        };
    };

    const priceBodyTemplatee = (rowData) => {
        if (rowData === '' || rowData === 0 || rowData === '0' || rowData === null) {
            return ''; // Simplified render
        }
        let numberValue = Number(rowData);
        if (isNaN(numberValue)) {
            return '';
        }

        const isNegative = rowData < 0;

        return <div style={{
            color: isNegative ? "red" : "black",
            // Removed fixed height/padding to let CSS table rules control compactness
            width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center"
        }}>
            {formatCurrency(rowData)}
        </div>
    };

    const formatCurrency = (value) => {
        if (value == null) {
            return ''
        }
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const formatAsPercentageY = (val) => {
        let numberValue = parseFloat(val);

        if (numberValue === 0) {
            return '';
        }

        return (
            <div style={{ color: numberValue < 0 ? 'red' : 'black' }}>
                {numberValue.toFixed(2)}
            </div>
        );
    };

    const formatAsPercentageP = (val) => {
        let numberValue = parseFloat(val);

        if (numberValue === 0) {
            return '';
        }

        return (
            <div style={{ color: numberValue < 0 ? 'red' : 'black' }}>
                {numberValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
            </div>
        );
    };


    const renderDecimalCell = (rowData, column) => {
        const value = rowData[column.field];
        const tooltipId = `tooltip-${(rowData.id || Math.random().toString(36).substr(2, 9))}`; // Unique ID for tooltip

        // Handle zero values
        if (value === 0 || value === '0') {
            return '';
        }

        // Add specific handling for % of Sales columns
        if (column.field.includes("% of Sales")) {
            if (typeof value === 'string' && value.includes('%')) {
                return value;
            }
            if (typeof value === 'number') {
                return value.toFixed(2) + '%';
            }
            return '';
        }

        if (value === 'Gross Profit 8') {
            return <span className="flex justify-between" style={{ fontWeight: "bold", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                Gross Profit
                <BsFillInfoCircleFill size={15} id={tooltipId} className='text-gray-500 hover:text-gray-900' />
                <Tooltip
                    target={`#${tooltipId}`}
                    content={rowData['tooltipTitle']} // Assuming 'tooltipTitle' contains the tooltip text
                    position="top"
                    className="custom-tooltip"
                />
            </span>
        }

        //* ----------New Code by Suraj---------------------------
        if (rowData['INCOME STATEMENT'] === 'Doomsday Ratio') {
            if (value != 'Doomsday Ratio') {
                return formatAsPercentageY(value);
            }
        }

        if (rowData['INCOME STATEMENT'] === 'Current Ratio') {
            if (value != 'Current Ratio') {
                return formatAsPercentageY(value);
            }
        }

        if (rowData['INCOME STATEMENT'] === 'Debt to Equity') {
            if (value != 'Debt to Equity') {
                return formatAsPercentageY(value);
            }
        }

        if (rowData['INCOME STATEMENT'] === 'Gross Profit') {
            if (value != 'Gross Profit') {
                return formatAsPercentageP(value);
            }
        }
        //! -------------------------------------




        if (rowData['INCOME STATEMENT'] == '') {
            if (column.field.includes("% of Sales")) {
                return ''
            }
            // console.log('value---->', rowData)
        }




        if (column.field === ColumnNameKey[0]) {
            if (value == 'Total Accounts Receievable' || value == 'Total Other Current Assets' || value == 'Materials for Future Jobs' || value == 'Due from/(to) Shareholder' || value == 'WIP-Costs in Excess of Billings' || value == 'Total Fixed Assets' || value == 'Total Other Assets' || value == 'Total Current Liabilities' || value == 'Total Long Term Liabilities' || value == 'Total Equity' || value == 'Working Capital' || value == 'Current Ratio' || value == 'Doomsday Ratio' || value == 'Debt to Equity' || value == 'Sales per FTE Top 25% $143,552' || value == 'Sales per Man. Staff Top 25% $228,244' || value == 'Sales per PM Top 25% $425,533') {

                return (
                    <span className="flex justify-between" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {value}
                        {/* <BsFillInfoCircleFill size={15} className='text-gray-500 hover:text-gray-900' title={rowData['tooltipTitle']} /> */}
                        <BsFillInfoCircleFill id={tooltipId} className='text-gray-500 hover:text-gray-900' />
                        <Tooltip
                            target={`#${tooltipId}`}
                            content={rowData['tooltipTitle']} // Assuming 'tooltipTitle' contains the tooltip text
                            position="top"
                            className="custom-tooltip"
                        />
                    </span>
                )
            }
        }


        const isLastThreeRows = projection.length - projection.indexOf(rowData) <= 3;

        if (isLastThreeRows) {
            if (value === 0) {
                return ''
            }
            return value;
        }


        if (value === 'Cash-end (previous month)') {
            return <span style={{ fontWeight: "bold", textAlign:'left'}} title={rowData['tooltipTitle']}>{value}</span>
        }

        if (value === 'Total' || value === 'Sub total' || value === 'COGS' || value === 'Gross Profit') {
            return <span className="flex justify-between" style={{ fontWeight: "bold", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                {value}
                {/* <BsFillInfoCircleFill size={15} title={rowData['tooltipTitle']} className='text-gray-500 hover:text-gray-900' /> */}
                <BsFillInfoCircleFill id={tooltipId} className='text-gray-500 hover:text-gray-900' />
                <Tooltip
                    target={`#${tooltipId}`}
                    content={rowData['tooltipTitle']} // Assuming 'tooltipTitle' contains the tooltip text
                    position="top"
                    className="custom-tooltip"
                />
            </span>
        }

        if (rowData['INCOME STATEMENT'] === 'Total' || rowData['INCOME STATEMENT'] === 'Sub total' || rowData['INCOME STATEMENT'] === 'Cash-end (previous month)') {
            return <div style={{ fontWeight: "bold", padding: '0' }}>{priceBodyTemplatee(value)}</div>;
        }


        if (value === 'Cash - end') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Cash - end') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        if (rowData['INCOME STATEMENT'] === 'COGS') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        if (value === 'Net Profit') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Net Profit') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }
        if (value === 'Total Expenses') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Total Expenses') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        // ---------------------------------------


        if (rowData['INCOME STATEMENT'] === 'Gross Profit 8') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }
        if (value === 'Expenses') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Expenses') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        if (value === 'Projections And Assumptions') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }
        
        if (value === 'NAHB Ratios') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }        

        if (rowData['INCOME STATEMENT'] === 'Projections And Assumptions') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }

        if (value === 'Balance Sheet') {
            return <span style={{ fontWeight: "bold" }}>{value}</span>
        }

        if (rowData['INCOME STATEMENT'] === 'Balance Sheet') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }
        if (rowData['INCOME STATEMENT'] === 'Gross Profit') {
            return <span style={{ fontWeight: "bold" }}>{priceBodyTemplatee(value)}</span>;
        }
        // ---------------------------------------
        if (value == "493304") {
            return priceBodyTemplatee(value);
        }
        const currentAssetsString = 'Current assets includes: Cash + Receivables + Other current assets LESS shareholder loan and due to related parties';
        const modifiedString = 'Current assets includes: Cash +R...';

        if (typeof value === 'string' && value === currentAssetsString) {
            // Display modified text
            const tooltip = 'Current assets includes: Cash + Receivables + Other current assets LESS shareholder loan and due to related parties';
            return (
                <span title={tooltip}>
                    {modifiedString}
                </span>
            );
        }
        if (typeof value === 'number' && value % 1 !== 0) {
            if (typeof value === 'string' && value.endsWith('%')) {
                return value;

            }
            if (value < 0) {
                <span style={{ color: "red" }}>
                    {priceBodyTemplatee(rowData)}
                </span>
            }

            return priceBodyTemplatee(value);
        }
        if (value === 0) {
            return ''
        }
        if (rowData['INCOME STATEMENT'] === 'Marketing & Sales' || rowData['INCOME STATEMENT'] === 'Admin wages' || rowData['INCOME STATEMENT'] === 'Facilities' || rowData['INCOME STATEMENT'] === 'Office' || rowData['INCOME STATEMENT'] === 'General & Admin' || rowData['INCOME STATEMENT'] === 'Total Accounts Receievable' || rowData['INCOME STATEMENT'] === 'JV Inc (exp)' || rowData['INCOME STATEMENT'] === 'Total Other Current Assets' || rowData['INCOME STATEMENT'] === 'Materials for Future Jobs' || rowData['INCOME STATEMENT'] === 'Due from/(to) Shareholder' || rowData['INCOME STATEMENT'] === 'WIP-Costs in Excess of Billings' || rowData['INCOME STATEMENT'] === 'Total Fixed Assets' || rowData['INCOME STATEMENT'] === 'Total Other Assets' || rowData['INCOME STATEMENT'] === 'Total Current Assets' || rowData['INCOME STATEMENT'] === 'Total Current Liabilities' || rowData['INCOME STATEMENT'] === 'Total Long Term Liabilities' || rowData['INCOME STATEMENT'] === 'Total Equity' || rowData['INCOME STATEMENT'] === 'Corp Tax Paid' || rowData['INCOME STATEMENT'] === 'Construction Financing' || rowData['INCOME STATEMENT'] === 'To balance cash' || rowData['INCOME STATEMENT'] === 'Total Other Income') {

            if (typeof value === 'number') {
                return priceBodyTemplatee(value);
            }
            // return value
            return (
                <div style={{  display: 'flex', alignItems: 'center' }}>
                    {value}
                </div>
            );
        }

        if (rowData['INCOME STATEMENT'] === 'Gross Profit') {
            if (value == 'Gross Profit') {
                return value
            }
            let numberValue;
            if (typeof value === 'string') {
                numberValue = parseFloat(value.replace("%", ""));
            } else {
                numberValue = parseFloat(value);
            }

            const formattedValue = `${numberValue.toFixed(2)}`;
            const color = numberValue < 0 ? 'red' : 'black';
            const backgroundColor = numberValue < 0 ? '#fcd9d9' : '';
            const border = numberValue < 0 ? '1px solid red' : '';

            return (
                <div style={{ color, backgroundColor, border }}>{formattedValue}</div>
            );
        }

        if (typeof value === 'number') {
            return priceBodyTemplatee(value);
        }
        return (
            <div style={{  display: 'flex', alignItems: 'center' }}>
                {value}
            </div>
        );
    };

    const openEditModal = (month, year) => {
        setSelectedMonth(month);
        setSelectedYear(year);
        setIsModalOpen(true);
    }

    const headerClick = (data, rowKey) => {

        var x = data.split(' ');
        const isCompleted = ColumnReComplated[rowKey] === 'Y';
        
        if (x.length == 2) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <span>{data}</span>
                    <button 
                        type="button" 
                        title='Edit Income Statement' 
                        style={{ 
                            width: '24px', 
                            height: '24px',
                            minWidth: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '50%',
                            border: isCompleted ? 'none' : '1px solid #2563eb',
                            backgroundColor: isCompleted ? '#15803d' : 'white',
                            color: isCompleted ? 'white' : '#2563eb', 
                            cursor: 'pointer',
                            padding: 0,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)' 
                        }} 
                        onClick={(e) => {
                            e.stopPropagation();
                            openEditModal(x[0], x[1]);
                        }} 
                    >
                        <FaPlus size={10} />
                    </button>
                </div>
            )
        }

        return (
            <React.Fragment>
                {data}
            </React.Fragment>
        )
    }



    const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column
                    field={ColumnNameKey[0]}
                    header={ColumnName[0]}
                    frozen
                    headerClassName="border-right-2"
                    headerStyle={{
                        fontSize: '13px',
                        minWidth: '340px',
                        textAlign: 'left',
                        borderBottom: '1px solid #e2e8f0',
                        borderRight: '2px solid #e2e8f0',
                        height: '40px',
                        backgroundColor: '#f8fafc',
                        color: '#475569',
                        textTransform: 'uppercase',
                        fontWeight: '600',
                        letterSpacing: '0.05em',
                        // Inline styles (highest CSS priority) so no CSS rule can override:
                        // PrimeReact adds position:sticky + left:0 for horizontal freeze
                        // but never adds top:0, so the th scrolls away vertically.
                        position: 'sticky',
                        top: '0px',
                        zIndex: 200,
                    }}
                />

                {ColumnNameKey.slice(1).map((row, i) => (
                    <Column
                        key={i + 1}
                        headerClassName={ColumnReComplated[row] == 'Y' ? "header-completed" : ""}
                        header={() => headerClick(ColumnName[i + 1], row)}
                        style={{
                            textAlign: 'center',
                            minWidth: ColumnName[i + 1] === 'Year' ? '250px' : '120px',
                            padding: '8px !important',
                            borderBottom: '1px solid #e2e8f0',
                            borderRight: '1px solid #e2e8f0',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: ColumnReComplated[row] == 'Y' ? "white" : '#475569',
                            backgroundColor:
                                i + 1 === 25 || i + 1 === 26 || i + 1 === 27 || i + 1 === 52 || i + 1 === 53 || i + 1 === 54 || i + 1 === 79 || i + 1 === 80 || i + 1 === 81
                                    ? '#e2e8f0' // Light Gray for Quarters
                                    : ColumnName[i + 1] === 'Year' || ColumnName[i + 1] === '% of Sales' 
                                        ? '#e2e8f0' 
                                        : ColumnReComplated[row] == 'Y' ? "#00D26A" : '#f8fafc'
                        }}
                    />
                ))}
            </Row>
        </ColumnGroup>
    );

    const toast = useRef(null);

    const closeModelAdd = (w) => {

        if (w === undefined) {
            setIsModalOpen(false);
        } else {
            toast.current.show({ severity: 'success', summary: 'Success', detail: w });
            getProjection();
            setIsModalOpen(false);
        }
    }

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(projection);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, 'products');
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };


    // ------------------------------------
    const StartDateAndEndDateSelect = () => {

        const startDate = new Date(selectOnStartDate);

        const endDate = new Date(selectOnEndDate);
        if (startDate > endDate) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Start date should be before end date.' });
            return;
        }

        updateDateInBackend(selectOnStartDate, selectOnEndDate);


    }
    const updateDateInBackend = (startDate, endDate) => {
        setIsLoading(true);
        var _body = {
            startDate: startDate,
            endDate: endDate,
        }

        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };

        fetch(Api.API_BASE_URL + 'change-startDate-endDate/2', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                getProjection();
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });
    }
    // ------------------------------------
    const onRowSelect = (e) => {
        // const rowData = e.data;
        // console.log('rowData ==>>', rowData);
        // alert('Selected Row Data: ' + rowData['INCOME STATEMENT']);
        console.log('Selected Row:', e.data); // Log the selected row data
        setSelectedProduct(e.data);

    };


    const renderHeader = () => {
        return (
            <div className="dashboard-toolbar">
                <div className="action-buttons" style={{ borderLeft: 'none', paddingLeft: 0, marginLeft: 0 }}>
                    <button type="button" className="btn-modern btn-secondary" onClick={exportExcel} title="Download Excel">
                        <FaFileExcel />
                        <span>Excel</span>
                    </button>
                    <button type="button" className="btn-modern btn-primary" onClick={StartDateAndEndDateSelect} title="Save & Refresh">
                        <IoMdRefresh />
                        <span>Refresh & Save</span>
                    </button>
                </div>

                <div className="toolbar-controls" style={{ marginLeft: "auto" }}>
                    <div className="control-group">
                        <label>Start Date</label>
                        <InputText
                            type="date"
                            className="modern-input"
                            value={selectOnStartDate}
                            onChange={(e) => setSelectOnStartDate(e.target.value)}
                        />
                    </div>
                    <div className="control-group">
                        <label>End Date</label>
                        <InputText
                            type="date"
                            className="modern-input"
                            value={selectOnEndDate}
                            onChange={(e) => setSelectOnEndDate(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="dashboard-wrapper">
            <Toast ref={toast} />
            <div className="dashboard-content-card">
                {renderHeader()}

                <div className="table-responsive-wrapper">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <DataTable
                            value={projection}
                            headerColumnGroup={headerGroup}
                            className="sticky-header-table compact-datatable"
                            scrollable
                            stripedRows
                            rowHover={true}
                            rowClassName={rowClass}
                            selection={selectedProduct}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            dataKey="INCOME STATEMENT"
                            selectionMode="single"
                            showGridlines={false} // Disabled gridlines for cleaner look
                            scrollHeight="flex"
                            style={{ width: '100%', height: '100%' }}
                            tableStyle={{ tableLayout: 'fixed', width: 'auto', borderCollapse: 'separate', borderSpacing: '0', }}
                        >
                            {ColumnNameKey.map((row, i) => (
                                <Column
                                    key={i}
                                    field={row}
                                    rowSpan={1}
                                    body={renderDecimalCell}
                                    className='projection-cell'
                                    style={{
                                        minHeight: '36px',
                                        textAlign: i === 0 ? 'left' : 'center',
                                        minWidth: i === 0 ? '340px' : '150px',
                                        padding: '8px 12px',
                                        borderBottom: '1px solid #e2e8f0', // Only bottom border
                                        borderRight: i === 0 ? '2px solid #e2e8f0' : 'none', // Only frozen column gets right border
                                        fontWeight: ColumnName[i] === 'Year' || ColumnName[i] === '% of Sales' ? '600' : '400',
                                        fontSize: '13px',
                                        color: '#334155',
                                        backgroundColor: i === 0 ? 'white' : (
                                            i + 1 === 26 || i + 1 === 27 || i + 1 === 28 || 
                                            i + 1 === 53 || i + 1 === 54 || i + 1 === 55 ||
                                            i + 1 === 80 || i + 1 === 81 || i + 1 === 82 
                                                ? '#f1f5f9' 
                                                : ColumnName[i] === 'Year' || ColumnName[i] === '% of Sales' || ColumnName[i] === 'Q1' || ColumnName[i] === 'Q2' || ColumnName[i] === 'Q3' || ColumnName[i] === 'Q4' 
                                                    ? '#f8fafc' 
                                                    : 'transparent'
                                        )
                                    }}
                                    bodyClassName={(rowData) =>
                                        rowData['INCOME STATEMENT'] === ""
                                            ? "blank-row"
                                            : rowData['INCOME STATEMENT'] === "Total" ||
                                                rowData['INCOME STATEMENT'] === "Net Profit" ||
                                                rowData['INCOME STATEMENT'] === "Cash - end" ||
                                                rowData['INCOME STATEMENT'] === "COGS" ||
                                                rowData['INCOME STATEMENT'] === "Gross Profit 8" ||
                                                rowData['INCOME STATEMENT'] === "Expenses" ||
                                                rowData['INCOME STATEMENT'] === "Total Expenses" ||
                                                rowData['INCOME STATEMENT'] === "Net Profit" ||
                                                rowData['INCOME STATEMENT'] === "Sub total" ||
                                                rowData['INCOME STATEMENT'] === "Balance Sheet" ||
                                                rowData['INCOME STATEMENT'] === "Projections And Assumptions" ||
                                                rowData['INCOME STATEMENT'] === "Gross Profit" ||
                                                rowData['INCOME STATEMENT'] === "NAHB Ratios"
                                                ? "net-profit-bg-text"
                                                : "archive-table-text"
                                    }
                                    frozen={i === 0}
                                />
                            ))}
                        </DataTable>
                    )}
                </div>
            </div>
            
            {/* -----------------------------------*/}
            {isModalOpen && <ProjectionAddModel visible={isModalOpen} projection={[]} closeModel={(e) => closeModelAdd(e)} setMonth={selectedMonth} setYear={selectedYear} />}
            {/* -------------------Projection Setting--------------*/}
            {isProjectionSetting && <ProjectionSettingViewModal getData={isProjectionSetting} closeModel={() => setIsProjectionSetting(false)} />}
        </div>
    )
}

export default Projection

